import * as React from 'react'
import { useTranslation } from 'react-i18next'
import Popover from '../Popover/Popover'
import styled, { css } from 'styled-components'
import Icon, { IconTypes } from '../Icons/Icon'
import { Style } from '../../styles'
import { ConversationSortColumn } from './InboxView'
import InboxFilterItem from './InboxFilterItem'

const Container = styled.div`
  background: white;
  min-width: 200px;
  box-shadow: 0 8px 16px -4px rgba(9,30,66,.25), 0 0 0 1px rgba(9,30,66,.08);
  border-radius: 3px;
  margin: 4px 0;
`

interface IProps {
  activator: JSX.Element
  value?: ConversationSortColumn
  onSubmit: (value?: ConversationSortColumn) => void
}

const ConversationSortPopover = (props: IProps) => {
  const { t } = useTranslation()
  const { activator, value } = props

  const [popoverActive, setPopoverActive] = React.useState(false)

  const onTogglePopover = () => {
    setPopoverActive(!popoverActive)
  }

  const onPopoverClose = () => {
    setPopoverActive(false)
  }

  const onStatusChange = (value: ConversationSortColumn) => {
    props.onSubmit(value)
    onPopoverClose()
  }

  const items: {
    icon: IconTypes
    label: string
    value: ConversationSortColumn
  }[] = [
      { icon: 'calendar', label: t(`ConversationSortColumn::${ConversationSortColumn.DATE_STARTED}`), value: ConversationSortColumn.DATE_STARTED },
      { icon: 'bell', label: t(`ConversationSortColumn::${ConversationSortColumn.LAST_ACTIVITY}`), value: ConversationSortColumn.LAST_ACTIVITY },
      { icon: 'star', label: t(`ConversationSortColumn::${ConversationSortColumn.PRIORITY}`), value: ConversationSortColumn.PRIORITY },
    ]

  return (
    <Popover
      active={popoverActive}
      activator={
        <div onClick={onTogglePopover}>
          {activator}
        </div>
      }
      onClose={onPopoverClose}
      placement='bottom-start'
    >
      <Container>
        {items.map(item => (
          <InboxFilterItem key={item.value} onClick={() => onStatusChange(item.value)} active={item.value === value}>
            <Icon icon={item.icon} />
            {item.label}
          </InboxFilterItem>
        ))}
      </Container>
    </Popover>
  )
}

export default ConversationSortPopover